// extracted by mini-css-extract-plugin
export default {"newsItemContainer":"page-news_newsItemContainer__4k4WF","newsDate":"page-news_newsDate__F72pt","newsTitle":"page-news_newsTitle__VLdj1","newsLine":"page-news_newsLine__GxVAO"};